import Vue from 'vue'
import router, { createRouter } from './routes'
import vueRouter from 'vue-router'
import store from './store/'
import home from './views/home/home.vue'
import addFence from './views/basicConfig/key-fence/components/addFence'
import Layout from './views/layout/index.vue'
import DataIndex from './views/dataIndex/index.vue'
import GetQueryString from "./common/utils/getQuery.js"
import Api from '@/api/index'
import Screen from './views/screen/index.vue'
Vue.use(vueRouter)
//开发环境时，为hash，路径包含#,部署发布时，为history
const recursionCreateRouter = (permis) => {
  let resRouter = permis.map(it => {
    let btn = []
    let itRouter = {}
    if (it.permisBtn) {
      btn = it.permisBtn.split('&');//构建按钮数组
    }
    if (it.permisPid && it.permisUrl && it.pagePath) {
      itRouter = {
        path: '/' + it.permisUrl,   
        name: it.permisUrl,
        component: (resolve) => {
          let componentPath = '';
          componentPath = it.pagePath;
          require([`./${componentPath}.vue`], resolve)
        },
        meta: {
            btnPermissions: btn,
            configName: it.configName,
            title: it.permisName
        }
      }
    } else if (it.permisPid == '0' || it.permisPid == 0) {
      itRouter = {
        path: '/' + it.permisUrl,
        component: home,
        meta: {
          requireAuth: true,
          title: it.permisName
        }
      }
    } else {
      itRouter = {
        path: '/' + it.permisUrl,
        component: Layout,
        meta: {
          requireAuth: true,
          title: it.permisName
        }
      }
    }

    if (it.children) {
      itRouter.children = recursionCreateRouter(it.children)
    }
    return itRouter
  })
  return resRouter
}
router.beforeEach(async(to, from, next) => {
  let login = store.state.login;
  if (to.path == '/login') {
    next();
    return;
  } else if (to.path == '/home') {
    let tokens = GetQueryString("token")
    var token = 'Bearer ' + tokens;
    
    const { code, data, success } = await Api.queryUserInfo(tokens && {token:token});
    if (!success) {
      next('/login');
      return;
    } else {
      store.commit("SET_LOGIN", true);
      store.commit("SET_USERINFO", data.userInfo);
      Api.queryMenuTree().then((res) => {//查询登录用户对应的菜单权限
        store.commit("SET_PERMISS", res.data.permission);//设置用户对应的显示菜单
        store.commit("SET_COMMONMENU", res.data.commonMenu);//设置用户对应的显示菜单
        let aRouter = [];  //路由数组
        aRouter = recursionCreateRouter(res.data.permission)
        let constantRouters = [{
          path: '/addkeyFence',
          permisUrl: '/addkeyFence',
          permisName: '添加',
          component:  addFence,
          meta: {
            display: false,
            requireAuth: true
          }
        },{
          path: '/editkeyFence',
          permisUrl: '/editkeyFence',
          permisName: '编辑',
          component:  addFence,
          meta: {
            display: false,
            requireAuth: true
          }
        }]
        let screenRouters = [{
          path: '/screen',
          permisUrl: 'screen',
          permisName: '大屏',
          component: Screen,
          meta: {
            title: '大屏',
            display: false,
            requireAuth: true
          }
        }]
        constantRouters.forEach(item => {
          aRouter.push(item)
        })
        screenRouters.forEach(item => {
          aRouter.push(item)
        })
        let allRouter = [{
          path: '/home',
          component: home,
          meta: {
            requireAuth: true,
          },
          children: constantRouters
        }]
        allRouter = allRouter.concat(aRouter)
        const errorRouter = {
          path: '**', // 错误路由
          redirect: '/home' //重定向
        }
        allRouter.push(errorRouter);
        router.matcher = createRouter().matcher;
        router.addRoutes(allRouter);//增加路由
      })
    }
    next();
    return;
  }

  if (!login) {
    next('/home');
  } else {//已登录
    if (!to.matched.length) {
      //路径不匹配
      next('/home');

    } else {
      next();

    }
  }
});



// WEBPACK FOOTER //
// ./src/permission.js